import React from 'react';

export function LoadingSpinner() {
  return (
    <div 
      className="fixed inset-0 bg-white/90 backdrop-blur-[2px] flex items-center justify-center z-[9999]" 
      style={{ 
        isolation: 'isolate',
        transform: 'translateZ(0)',
        backfaceVisibility: 'hidden'
      }}
    >
      <div className="flex flex-col items-center">
        <div 
          className="h-12 w-12 rounded-full border-[3px] border-t-indigo-600 border-indigo-200 animate-spin" 
          style={{ 
            animationDuration: '0.6s',
            willChange: 'transform'
          }}
        />
        <p className="mt-4 text-sm text-gray-600 font-medium">Loading...</p>
      </div>
    </div>
  );
}